export default {
  text: '单图片',
  // 在低代码平台展示的组件名称
  icon: 'http://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202310/27/9f502_20231027161718.png',
  // 在低代码平台展示的组件图标
  name: 'SmImage',
  // 固定
  group: '基础组件（不支持小程序）',
  sort: 0,
  // 排序
  schema: {
    /* 该配置用于描述该组件 */
    type: 'object',
    // 固定
    widget: 'SmImage',
    // 该组件唯一标记，需要和导出组件名称一致，重要
    containerType: 'template',
    // 固定
    properties: {} // 固定
  },
  setting: {
    /* 该配置用于低代码平台右侧的属性配置 */
    props: {
      // type: 'SmImage', //   固定
      // title: '属性配置', // 固定
      // properties: {
      //     // 以下的属性配置，根据组件的需要自己添加，添加规则参考schema 规范
      //     title: {
      //         title: '标签配置',
      //         type: 'string',
      //         widget: 'htmlInput',
      //     },
      // },
      widget: 'MEH5MediaImageSettingWidget',
      type: 'object'
    }
  }
};